import { TeamBasic, TeamColor } from "common";
import TeamLogo from "./logo";

export default function TeamLegend({
  awayTeam,
  homeTeam,
}: {
  awayTeam: TeamBasic & TeamColor;
  homeTeam: TeamBasic & TeamColor;
}) {
  return (
    <div className="flex flex-row gap-4">
      <div className="flex items-center gap-2">
        <TeamLogo team={awayTeam} size={"md"} />
        <div className="text-title-lg-medium text-dark">
          {awayTeam.abbreviation}
        </div>
        <div
          className="w-6 h-[0.375rem] rounded-md"
          style={{ backgroundColor: `#${awayTeam.primaryColor}` }}
        ></div>
      </div>
      <div className="flex items-center gap-2">
        <TeamLogo
          team={homeTeam}
          size={"md"}
        />
        <div className="text-title-lg-medium text-dark">
          {homeTeam.abbreviation}
        </div>
        <div
          className="w-6 h-[0.375rem] rounded-md"
          style={{ backgroundColor: `#${homeTeam.primaryColor}` }}
        ></div>
      </div>
    </div>
  );
}
